import PLANS_ACTION from '../../constants/action'
import PLANS_PATH from '../../constants/path'
import getByIdPlanSelector from '../../selectors/get-by-id'
import { setIdReduxAction } from '../../../redux/actions/set-id'

function updateCurrentPlanAction (instanceOrId) {
  return (dispatch, getState) => {
    let instance
    if (typeof instanceOrId === 'number') {
      instance = getByIdPlanSelector(instanceOrId)(getState())
    } else {
      instance = instanceOrId
    }
    dispatch(setIdReduxAction({
      type: PLANS_ACTION.UPDATE_CURRENT,
      payload: {
        path: PLANS_PATH.CURRENT,
        instance
      }
    }))
  }
}

export default updateCurrentPlanAction
